import { createSlice, createAsyncThunk  } from '@reduxjs/toolkit';
import UserService from "../../services/user-service";

const initialState = {
    loading: false,
    users: [],
    error: ''
}

export const fetchClass = createAsyncThunk('custClass/fetchClass', async () => {
    const response = await UserService.getClassification();
    return response.data;
})

const custClassSlice = createSlice({
    name: 'custClass',
    initialState,
    extraReducers: builder => {
        builder.addCase(fetchClass.pending, state => {
            state.loading = true
        })
        builder.addCase(fetchClass.fulfilled, (state, action) => {
            state.loading = false
            state.users = action.payload
            state.error = ''
        })
        builder.addCase(fetchClass.rejected, (state, action) => {
            state.loading = false
            state.users = []
            state.error = action.error.message
        })
    }
})

export default custClassSlice.reducer
